const configuration = {
  spaces: process.env.REACT_APP_DIGITALOCEANSPACES,
  bucketName: process.env.REACT_APP_DO_BUCKETNAME,
};

export default configuration;
